import { Card } from "@general-backoffice/core";
import React from "react";
import { useTranslation } from "react-i18next";
import { Button, Card as BCard, CardBody as BCardBody, InputGroup, Spinner } from "reactstrap";

import QRCodeModal from "../qrCode/QRCodeModal";
import generateReferrerLink from "./utils/generateReferrerLink";

interface ReferralLinkCardProps {
  link?: string | null;
  isLoading: boolean;
  onClickButton: () => void;
  title: string;
  subtitle: string;
}

const ReferralLinkCard = ({ link, isLoading, onClickButton, title, subtitle }: ReferralLinkCardProps) => {
  const [QRToShow, setQRToShow] = React.useState<{ link: string; filename: string } | null>(null);
  const { t } = useTranslation("referrer", { keyPrefix: "referralLinkCard" });

  return (
    <>
      <QRCodeModal value={QRToShow?.link ?? ""} filename={QRToShow?.filename ?? ""} close={() => setQRToShow(null)} />
      <BCard className="overflow-hidden">
        <Card.Header title={title} subtitle={subtitle} isLoading={isLoading} />
        <BCardBody>
          <InputGroup>
            {/* `text-truncate` supplies the ellipsis; the previous
                text-nowrap + overflow-hidden pair clipped the link
                mid-character with no sign it was truncated. */}
            <div className="form-control d-flex align-items-center" style={{ minWidth: 0 }}>
              <span
                className="text-truncate"
                title={link || undefined}
                style={{ filter: !link ? "blur(3.5px)" : "", userSelect: !link ? "none" : "auto" }}
              >
                {link || generateReferrerLink("test")}
              </span>
            </div>
            {link && (
              <>
                <Button
                  onClick={() => setQRToShow({ link, filename: "share_link" })}
                  color="default"
                  className="m-0 rounded-0"
                  disabled={isLoading}
                  aria-label={t("showQrCode")}
                  title={t("showQrCode")}
                >
                  <i className="fas fa-qrcode" aria-hidden="true" />
                </Button>
                <Button
                  onClick={onClickButton}
                  color="default"
                  className="m-0"
                  style={{ borderBottomLeftRadius: 0, borderTopLeftRadius: 0 }}
                  disabled={isLoading}
                >
                  {t("copyButton")}
                </Button>
              </>
            )}
            {!link && (
              <Button
                onClick={onClickButton}
                color="default"
                className="m-0 shadow-none"
                style={{ borderBottomLeftRadius: 0, borderTopLeftRadius: 0, width: 100 }}
                disabled
              >
                {isLoading ? <Spinner size="sm" color="white" /> : t("revealButton")}
              </Button>
            )}
          </InputGroup>
          {!link && !isLoading && <div className="text-sm text-danger mt-3 mb--3 text-center">{t("noBotWarning")}</div>}
        </BCardBody>
      </BCard>
    </>
  );
};

export default ReferralLinkCard;
